import { render } from "./ChangePill.vue?vue&type=template&id=568e28f6&scoped=true"
import script from "./ChangePill.vue?vue&type=script&lang=js"
export * from "./ChangePill.vue?vue&type=script&lang=js"

import "./ChangePill.vue?vue&type=style&index=0&id=568e28f6&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-568e28f6"]])

export default __exports__